// extracted by mini-css-extract-plugin
export default {"tag":"AlertTag_tag__SpZLS"};